export class PesquisaDados {
  public CD_FUNDACAO: string;
  public CD_EMPRESA: string;
  public CD_PLANO: string;
  public CD_SIT_PLANO: string;
  public NUM_MATRICULA: string;
  public NOME: string;
  public ReCAPTCHATokenV2: string;
  public ReCAPTCHATokenV3: string;
}
